import { ArrowUpRight, BookOpenCheck, Sparkles } from "lucide-react";

const prompts = [
  "Como começo a montar uma rotina sem apostas?",
  "Qual oração posso fazer quando a vontade chega?",
  "Como academia e sono ajudam no recomeço?",
];

export default function AssistantShowcaseSection({ onOpen }) {
  return (
    <section className="assistant-section" id="guia-do-leitor" data-testid="assistant-showcase">
      <div className="assistant-showcase-inner">
        <div className="assistant-showcase-copy"><p className="assistant-eyebrow">GUIA DO LEITOR · GEMINI 3 FLASH</p><h2>Uma pergunta honesta pode abrir a próxima página.</h2><p>Converse com uma IA treinada para explicar o conteúdo do livro, sugerir hábitos pequenos e lembrar quando é hora de procurar apoio humano.</p><div className="assistant-safety-line"><Sparkles size={15} /> IA de apoio educativo · sem diagnóstico ou promessa de cura</div></div>
        <div className="assistant-showcase-card"><div className="assistant-card-top"><span><BookOpenCheck size={16} /> disponível no site</span><i>IA</i></div><p>“Por onde eu começo hoje?”</p><div className="assistant-prompt-list">{prompts.map((prompt, index) => <button type="button" key={prompt} onClick={() => onOpen(prompt)} data-testid={`assistant-suggestion-${index + 1}`}>{prompt}<ArrowUpRight size={15} /></button>)}</div><button className="assistant-open-button" type="button" onClick={() => onOpen("")} data-testid="assistant-showcase-open">Abrir conversa <ArrowUpRight size={16} /></button></div>
      </div>
    </section>
  );
}
